// extracted by mini-css-extract-plugin
export default {"container":"GalleryGridReviewDisable_container__g9ncL","note":"GalleryGridReviewDisable_note__XAqCM","rating-wrapper":"GalleryGridReviewDisable_rating-wrapper__5rMix"};